// API client. The console talks to api-monitor.miglioresoftware.app with the session cookie
// (HttpOnly, set by the SSO callback): no token ever reaches JavaScript.

const LOCAL = location.hostname === 'localhost' || location.hostname === '127.0.0.1';

export const API_URL = (import.meta.env.VITE_API_URL ?? (LOCAL ? 'http://localhost:8787' : 'https://api-monitor.miglioresoftware.app')).replace(/\/$/, '');

export class NotSignedIn extends Error {}

export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
  ) {
    super(message);
  }
}

export function signIn(returnTo = location.pathname + location.search) {
  location.assign(`${API_URL}/auth/sso/start?return_to=${encodeURIComponent(returnTo)}`);
}

export async function api<T>(path: string, init?: RequestInit & { json?: unknown }): Promise<T> {
  const headers = new Headers(init?.headers);
  let body = init?.body;
  if (init?.json !== undefined) {
    headers.set('content-type', 'application/json; charset=utf-8');
    body = JSON.stringify(init.json);
  }
  const response = await fetch(`${API_URL}${path}`, { ...init, headers, body, credentials: 'include' });
  if (response.status === 401) throw new NotSignedIn();
  if (!response.ok) {
    const payload = (await response.json().catch(() => null)) as { error?: { code: string; message: string } } | null;
    throw new ApiError(response.status, payload?.error?.code ?? 'error', payload?.error?.message ?? `Errore ${response.status}`);
  }
  return (await response.json()) as T;
}

export function query(params: Record<string, string | number | undefined | null | false>) {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) if (value !== undefined && value !== null && value !== false && value !== '') search.set(key, String(value));
  const text = search.toString();
  return text ? `?${text}` : '';
}
